import { createFileRoute, redirect } from '@tanstack/react-router';

/**
 * NOT-339 §3.3 — retired Contract detail. The parent `contracts` route already
 * redirects, but this stub keeps `/dashboard/contracts/:id` matchable so old
 * external links resolve to the Jobs list instead of 404ing.
 */
export const Route = createFileRoute('/_dashboard/dashboard/contracts/$id')({
  beforeLoad: () => {
    throw redirect({ to: '/dashboard/jobs' });
  },
  component: () => null,
});
